import React, { useState, useEffect } from "react";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  Slide,
  IconButton,
  TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";

import { nameValidation, descriptionValidation, endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function CategoryDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  // props value
  const { open, handleClose, dataId, dataName, dataDescription } = props;

  // state logic start
  const initialState = {
    name: "",
    nameError: "",
    description: "",
    descriptionError: "",
  };

  const [state, setState] = useState({ ...initialState });

  const handleNameChange = (e) => {
    const value = e.target.value;
    setState({
      ...state,
      name: value,
      nameError:
        value && !value.match(nameValidation.regex)
          ? nameValidation.message
          : "",
    });
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    setState({
      ...state,
      description: value,
      descriptionError:
        value && !value.match(descriptionValidation.regex)
          ? descriptionValidation.message
          : "",
    });
  };
  // state logic end

  // submit button disable state logic start
  const [isSubmitBtnDisbaled, setIsSubmitBtnDisbaled] = useState(true);

  useEffect(() => {
    setIsSubmitBtnDisbaled(
      (!state.name || state.nameError ? true : false) ||
        (!state.description || state.descriptionError ? true : false)
    );
  }, [state]);
  // submit button disable state logic end

  // handle submit logic start
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const handleCatchLogic = (error) => {
      setSubmitBtnLoading(false);
      if (error.response) {
        customToast.error(error.response.data?.message);
      } else {
        customToast.error(error.message);
      }
    };

    const requestBody = {
      name: state.name,
      description: state.description,
    };
    setSubmitBtnLoading(true);
    if (!dataId) {
      axios
        .post(`${endpoint}/api/category`, requestBody)
        .then(() => {
          setSubmitBtnLoading(false);
          customToast.success("Category added successfully");
          handleClose(true);
        })
        .catch((error) => handleCatchLogic(error));
    } else {
      axios
        .put(`${endpoint}/api/category/${dataId}`, requestBody)
        .then(() => {
          setSubmitBtnLoading(false);
          customToast.success("Category updated successfully");
          handleClose(true);
        })
        .catch((error) => handleCatchLogic(error));
    }
  };
  // handle submit logic end

  // reset & value assign logic start
  useEffect(() => {
    if (open) {
      setState({
        ...initialState,
        ...(dataName && { name: dataName }),
        ...(dataDescription && { description: dataDescription }),
      });
    }
  }, [open]);
  // reset & value assign logic end

  return (
    <Dialog
      open={open}
      scroll="paper"
      fullScreen={fullScreen}
      fullWidth
      TransitionComponent={Transition}
    >
      <form onSubmit={handleSubmit} autoComplete="off">
        <DialogContent>
          <Grid container justifyContent="flex-end" sx={{ mb: 2 }}>
            <IconButton onClick={() => handleClose(false)}>
              <CloseIcon />
            </IconButton>
          </Grid>
          <Grid container justifyContent="center" spacing={3}>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                label="Name"
                name="name"
                value={state.name}
                onChange={handleNameChange}
                error={state.nameError ? true : false}
                helperText={state.nameError}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                label="Description"
                name="description"
                value={state.description}
                onChange={handleDescriptionChange}
                error={state.descriptionError ? true : false}
                helperText={state.descriptionError}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            color="secondary"
            variant="contained"
            size="large"
            fullWidth
            type="submit"
            disabled={isSubmitBtnDisbaled}
            loading={submitBtnLoading}
          >
            Save
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
}
